export default function LoadingScreen() {
  const tips = [
    "It's still a work in progress!",
    'Enemies spawn and seek your Builder after 2 minutes!',
    'Only an efficient economy, focused defense, and a strong build / upgrade order will win you the game!',
    'Learning the build menu keybindings will help you build faster and more efficiently!',
  ];
  // const toBeImplementedTips = [
  //   'Pressing spacebar will move your camera to the most recent alert location',
  // ];
  const randomTip = tips[Math.floor(Math.random() * tips.length)];
  // const randomToBeImplementedTip =
  //   toBeImplementedTips[Math.floor(Math.random() * toBeImplementedTips.length)];
  return (
    <div
      className="w-screen h-screen flex flex-col items-center justify-center relative bg-cover bg-center"
      style={{
        backgroundImage: "url('/assets/backgrounds/loading/Northfolk_Background_16.webp')",
      }}
    >
      {/* Text container with dark translucent backdrop */}
      <div className="bg-black/80 px-8 py-6 rounded-lg text-center flex flex-col items-center gap-3">
        <h2 className="text-white text-6xl font-bold">Loading...</h2>
        <p className="text-white text-lg">
          Tip: <span>{randomTip}</span>
        </p>
        {/* <p className="text-white text-lg mt-8">
          To be implemented: <span>{randomToBeImplementedTip}</span>
        </p> */}
      </div>
    </div>
  );
}
